import React from 'react';
import styled from 'styled-components';
import Typography from 'kingpin/atoms/Typography';
import { InputRow } from '../../../CustomerLaneCommitsBoard/SlideOut/styles';

const Row = styled(InputRow)`
  height: 30px;
  border-bottom: 1px solid var(--color-bg-input);
  padding: 0px 4px;
  margin-bottom: 0px;
  &:last-child {
    border-bottom: 0;
  }
`;

const Metric = ({
  value,
  label,
  testId,
}: {
  value: string;
  label: string;
  testId: string;
}) => (
  <Row data-testid={testId}>
    <Typography.Body type="Label">{`${label} `}</Typography.Body>
    <Typography.Body type="Label" color={'var(--color-grey-4)'}>
      {value}
    </Typography.Body>
  </Row>
);

export default Metric;
